import { render, staticRenderFns } from "./uploadAddon.vue?vue&type=template&id=067bce3a&scoped=true"
import script from "./uploadAddon.vue?vue&type=script&lang=ts"
export * from "./uploadAddon.vue?vue&type=script&lang=ts"
import style0 from "./uploadAddon.vue?vue&type=style&index=0&id=067bce3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067bce3a",
  null
  
)

export default component.exports